import { triggerUpdate } from '../serviceWorkerRegistration'

// Shared pull-to-refresh handler so every page feels the same:
//   - bumps the service worker (so the gesture also doubles as
//     "get me out of a stuck build")
//   - awaits whatever refetch functions the caller cares about
//   - floors the spin at 1s so a cache hit doesn't cut the spinner
//     mid-rotation (matches Tailwind's animate-spin period)
//
// Pages without data hooks can pass an empty array — the gesture
// still resolves after the floor, giving the same visual feedback as
// data pages.
export async function performRefresh(refetches = []) {
  triggerUpdate()
  await Promise.all([
    Promise.allSettled(
      (refetches || []).map((fn) => (typeof fn === 'function' ? fn() : null)),
    ),
    new Promise((resolve) => setTimeout(resolve, 1000)),
  ])
}
